export default __webpack_public_path__ + "3940f517cf180d804440ec472ac7140a.png";